const PLATFORM_LABELS: Record<string, string> = {
  to_attend: "To attend",
  to_experience: "To experience",
  to_eat: "To eat",
  to_try: "To try",
  to_buy: "To buy",
  to_watch: "To watch",
  to_read: "To read",
};

export const formatPlatform = (value?: string) => {
  if (!value) return "Web";
  const key = value.toLowerCase();
  if (PLATFORM_LABELS[key]) return PLATFORM_LABELS[key];
  return key
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export { PLATFORM_LABELS };
